var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"scrollUp","title":"Scroll To Top"}},[_c('a',{staticClass:"fas fa-arrow-up",on:{"click":function($event){return _vm.scrollToTop()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }